export const matrixEnterpriseOptions = [
  { label: 'Sim', value: true },
  { label: 'Não', value: false },
];
